module.exports = __webpack_public_path__ + "img/penta5ex_icon.17a02d80.png";